import { supabase } from "../lib/supabase";
import { PAGE_SIZE } from "./billableConversionsExportService";

// Daily billable vs charged rows for the QuickBooks Reconciliation tab
// (DEV-2926), from the support-only RPC of migration 109. p_start and p_end are
// "YYYY-MM-DD" UTC days, both included.

// Each request aggregates its advertisers' conversions again, so a request stays
// small enough for the statement timeout whatever the size of the table.
export const ADVERTISERS_PER_REQUEST = 10;

async function fetchChunk(start, end, advertiserIds) {
  const out = [];
  let cursor = {};
  for (;;) {
    const { data, error } = await supabase.rpc("support_billing_reconciliation", {
      p_start: start,
      p_end: end,
      p_limit: PAGE_SIZE,
      p_advertiser_ids: advertiserIds,
      ...cursor,
    });
    if (error) {
      throw new Error("Could not load the reconciliation.");
    }
    const page = data ?? [];
    // Only an empty page ends it: PostgREST may cap a page below PAGE_SIZE.
    if (page.length === 0) return out;
    out.push(...page);
    const last = page[page.length - 1];
    cursor = { p_after_advertiser_id: last.advertiser_id, p_after_day: last.day };
  }
}

// advertiserIds: the advertisers to read, or null for every advertiser.
export async function fetchBillingReconciliation(start, end, advertiserIds) {
  if (!supabase) {
    throw new Error("Supabase client is not initialized");
  }
  if (advertiserIds === null) return fetchChunk(start, end, null);
  const out = [];
  for (let i = 0; i < advertiserIds.length; i += ADVERTISERS_PER_REQUEST) {
    out.push(...await fetchChunk(start, end, advertiserIds.slice(i, i + ADVERTISERS_PER_REQUEST)));
  }
  return out;
}
